export const ActionTypes = {
    MODAL_SHOW: 'MODAL_SHOW',
    MODAL_HIDE: 'MODAL_HIDE'
};
